import React from 'react'
import { Button, Divider, Input, Typography, theme } from 'antd'
import { useTranslation } from 'react-i18next'
import './FilterPanel.css'

interface FilterPanelProps {
  searchText: string
  selectedCount: number
  totalCount: number
  showEnterHint?: boolean
  placeholder?: string
  width?: number | string
  children: React.ReactNode
  onSearchChange: (text: string) => void
  onSearch?: () => void
  onClear: () => void
}

const { Text } = Typography

const FilterPanel: React.FC<FilterPanelProps> = ({
  searchText,
  onSearchChange,
  onSearch,
  selectedCount,
  totalCount,
  onClear,
  showEnterHint = false,
  placeholder,
  width = '100%',
  children
}) => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width, height: '100%' }}>
      <Input.Search
        placeholder={placeholder || t('global:search')}
        value={searchText}
        onChange={e => onSearchChange(e.target.value)}
        onSearch={val => val && onSearch?.()}
        allowClear
      />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text type="secondary">{selectedCount ? `${selectedCount} / ${totalCount}` : ''}</Text>
        <Button onClick={onClear} size="small" type="text">
          <Text type="secondary">{t('global:clear-selections')}</Text>
        </Button>
      </div>

      <Divider style={{ margin: 0 }} />

      <div className="filter-panel-content" style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
        {children}
      </div>

      <div
        style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: token.colorTextQuaternary }}
      >
        <span>{t('global:shift-click-select-range')}</span>
        {showEnterHint && <span>{t('global:enter-select-matches')}</span>}
      </div>
    </div>
  )
}

export { FilterPanel }
export type { FilterPanelProps }
